import { useEffect, useRef } from 'react';

async function fetchMigrationToken(accessToken: string): Promise<string | null> {
  console.log('[LegacyTokenMigration] Fetching migration token from API');

  const response = await fetch(import.meta.env.VITE_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      query: '{ __typename }',
    }),
  });

  console.log('[LegacyTokenMigration] GraphQL response received', {
    status: response.status,
    ok: response.ok,
  });

  const clerkSignInToken = response.headers.get('x-clerk-signin-token');
  console.log('[LegacyTokenMigration] Clerk sign-in token from header:', clerkSignInToken ? 'FOUND' : 'NOT FOUND');

  return clerkSignInToken;
}

function redirectToSignin() {
  console.log('[LegacyTokenMigration] Redirecting to sign in');
  localStorage.removeItem('token_data');
  window.location.href = '/signin';
}

function redirectToMigration(token: string) {
  const primaryDomain = __TOWN_SQUARE_URL__;
  const returnUrl = window.location.href;
  const migrationUrl = `${primaryDomain}/migrate-session?token=${encodeURIComponent(token)}&return=${encodeURIComponent(returnUrl)}`;

  console.log('[LegacyTokenMigration] Redirecting to migration endpoint', {
    primaryDomain,
    returnUrl,
    migrationUrl,
  });

  window.location.href = migrationUrl;
}

async function migrate() {
  console.log('[LegacyTokenMigration] Starting migration');

  const tokenData = localStorage.getItem('token_data');
  console.log('[LegacyTokenMigration] Token data in localStorage:', tokenData ? 'FOUND' : 'NOT FOUND');

  // Guard: no token
  if (!tokenData) {
    console.log('[LegacyTokenMigration] No token data found, redirecting to signin');
    redirectToSignin();
    return;
  }

  try {
    const parsed = JSON.parse(tokenData);
    console.log('[LegacyTokenMigration] Parsed token data', {
      hasAccessToken: !!parsed.access_token,
      hasRefreshToken: !!parsed.refresh_token,
    });

    const clerkSignInToken = await fetchMigrationToken(parsed.access_token);

    // Guard: no migration token
    if (!clerkSignInToken) {
      console.log('[LegacyTokenMigration] No migration token received, redirecting to signin');
      redirectToSignin();
      return;
    }

    // Clear and migrate
    console.log('[LegacyTokenMigration] Migration token received, clearing legacy token and redirecting');
    localStorage.removeItem('token_data');
    redirectToMigration(clerkSignInToken);
  } catch (error) {
    console.error('[LegacyTokenMigration] Error during migration:', error);
    redirectToSignin();
  }
}

export function LegacyTokenMigration() {
  console.log('[LegacyTokenMigration] Component mounted');
  const hasStarted = useRef(false);

  useEffect(() => {
    // Guard: prevent double execution in React Strict Mode
    if (hasStarted.current) {
      console.log('[LegacyTokenMigration] Already started, skipping');
      return;
    }

    hasStarted.current = true;
    migrate();
  }, []);

  return null;
}
